import { Navigate, useRoutes } from 'react-router-dom';
import NotFound from '../../../pages/Page404';
import constants from '../../../constants';
import DashboardLayout from '../../../layouts/dashboard';
import Login from '../../../pages/Login';
import Users from '../../../pages/Users';
import RequireAuth from '../../../features/routing/components/RequireAuth';
import LogoOnlyLayout from '../../../layouts/LogoOnlyLayout';
import UsersReservation from '../../../pages/UsersReservation';
import RoleRoute from './RoleRoute';
import Dashboard from '../../../pages/Dashboard';
import ModeratorStatisitcs from '../../../pages/ModeratorStatistics';
import UserStatistics from '../../../pages/UserStatistics';
import CustomTrainings from '../../../pages/CustomTrainings';
import Workouts from '../../../pages/Workouts';
import TrainingsPage from '../../../pages/trainings/Trainings';
import PersonalTrainingsPage from '../../../pages/trainings/PersonalTrainings';
import TrainingSession from '../../../pages/TrainingSession';
import TrainingSessionDetailPage from '../../../pages/TrainingSessionDetailPage';
import ReleaseNotesPage from '../../../pages/ReleaseNotesPage';
import ReleaseNotesAdminPage from '../../../pages/admin/ReleaseNotesAdminPage';
import LocationsManagementPage from '../../../pages/admin/LocationsManagementPage';
import AdminWorkoutsReviewPage from '../../../pages/admin/AdminWorkoutsReviewPage';


// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: constants.routes.DASHBOARD.path,
      element: <RequireAuth><DashboardLayout /></RequireAuth>,
      children: [
        { index: true, element: <Dashboard /> },
        { path: constants.routes.PERSONAL_TRAININGS.path, element: ( <RoleRoute roles={constants.routes.PERSONAL_TRAININGS.roleIds}><PersonalTrainingsPage /></RoleRoute>),},
        { path: constants.routes.GROUP_TRAININGS.path, element: (<RoleRoute roles={constants.routes.GROUP_TRAININGS.roleIds}><TrainingsPage /></RoleRoute>),},
        { path: constants.routes.USERS.path, element: <RoleRoute roles={constants.routes.USERS.roleIds}><Users /></RoleRoute> },
        { path: constants.routes.USERS_RESERVATION.path, element: <RoleRoute roles={constants.routes.USERS_RESERVATION.roleIds}><UsersReservation /></RoleRoute> },
        { path: constants.routes.MODERATOR_USERS_STATISTICS.path, element: <RoleRoute roles={constants.routes.MODERATOR_USERS_STATISTICS.roleIds}><ModeratorStatisitcs /></RoleRoute> },
        { path: constants.routes.USER_STATISTICS.path, element: <RoleRoute roles={constants.routes.USER_STATISTICS.roleIds}><UserStatistics /></RoleRoute> },
        { path: constants.routes.CUSTOM_TRAININGS.path, element: <RoleRoute roles={constants.routes.CUSTOM_TRAININGS.roleIds}><CustomTrainings /></RoleRoute> },
        { path: constants.routes.WORKOUTS_MANAGEMENT.path, element: <RoleRoute roles={constants.routes.WORKOUTS_MANAGEMENT.roleIds}><Workouts /></RoleRoute> },
        { path: constants.routes.TRAINING_SESSION.path, element: <RoleRoute roles={constants.routes.TRAINING_SESSION.roleIds}><TrainingSession /></RoleRoute> },
        { path: constants.routes.TRAINING_SESSION_DETAILS.path, element: <RoleRoute roles={constants.routes.TRAINING_SESSION_DETAILS.roleIds}><TrainingSessionDetailPage /></RoleRoute> },
        { path: constants.routes.RELEASE_NOTES.path, element: <RoleRoute roles={constants.routes.RELEASE_NOTES.roleIds}><ReleaseNotesPage /></RoleRoute> },
        { path: constants.routes.ADMIN_RELEASE_NOTES.path, element: <RoleRoute roles={constants.routes.ADMIN_RELEASE_NOTES.roleIds}><ReleaseNotesAdminPage /></RoleRoute> },
        { path: constants.routes.LOCATIONS_MANAGEMENT.path, element: <RoleRoute roles={constants.routes.LOCATIONS_MANAGEMENT.roleIds}><LocationsManagementPage /></RoleRoute> },
        { path: constants.routes.ADMIN_WORKOUTS_REVIEW.path, element: <RoleRoute roles={constants.routes.ADMIN_WORKOUTS_REVIEW.roleIds}><AdminWorkoutsReviewPage /></RoleRoute> },
      ]
    },
    {
      path: constants.routes.HOME.path,
      element: <LogoOnlyLayout />,
      children: [
        { index: true, element: <Navigate to={constants.routes.DASHBOARD.path} /> },
        { path: constants.routes.LOGIN.path, element: <Login /> },
        { path: constants.routes.NOTFOUND.path, element: <NotFound /> }
      ]
    },
    { path: '*', element: <Navigate to={constants.routes.NOTFOUND.path} replace /> }
  ]);
}
